const PN = [
    { id: "0", value: "正變負" },
    { id: "1", value: "負變正" },
];

export default PN  